import { PaymentResultResponse } from '../types/PaymentResult';

export type PaymentFailureCategory = 'USER_ABORT' | 'DECLINED' | 'OTHER';

const USER_ABORT_FAILURE_CODES = ['payment_method_customer_decline'];

const PAYMENT_DECLINED_FAILURE_CODES = [
  'payment_method_provider_decline',
  'payment_intent_payment_attempt_failed',
];

export const categorizePaymentFailure = (
  failureCode?: PaymentResultResponse['failureCode']
): PaymentFailureCategory => {
  if (failureCode) {
    if (USER_ABORT_FAILURE_CODES.includes(failureCode)) {
      return 'USER_ABORT';
    }
    if (PAYMENT_DECLINED_FAILURE_CODES.includes(failureCode)) {
      return 'DECLINED';
    }
  }

  return 'OTHER';
};

export const getPaymentFailureAlertCopy = (
  category: PaymentFailureCategory
): { titleTranslationKey: string; textTranslationKey: string } => {
  switch (category) {
    case 'USER_ABORT':
      return {
        titleTranslationKey:
          'payments.errorAlert.paymentFailure.userAbort.title',
        textTranslationKey: 'payments.errorAlert.paymentFailure.userAbort.text',
      };
    case 'DECLINED':
      return {
        titleTranslationKey:
          'payments.errorAlert.paymentFailure.declined.title',
        textTranslationKey: 'payments.errorAlert.paymentFailure.declined.text',
      };
    default:
      return {
        titleTranslationKey: 'payments.errorAlert.paymentFailure.other.title',
        textTranslationKey: 'payments.errorAlert.paymentFailure.other.text',
      };
  }
};
